var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/circleci/project/@static/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["@modules/modals/templates/benefits-package-view.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"modal-inner-container ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSize"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsPadding"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsBackgroundColor"), env.opts.autoescape);
output += "\">\n    <button class=\"modal__close-btn btn\" data-js-ui=\"close-modal\">\n        <span class=\"modal__close-btn-label\" data-auto-translate=\"true\">Close</span>\n        <span class=\"modal__close-btn-icon icon-close\"></span>\n    </button>\n    <button class=\"modal__print-btn btn\" data-js-ui=\"print-modal\">\n        <span class=\"modal__print-btn-label\" data-auto-translate=\"true\">Print</span>\n        <span class=\"modal__print-btn-icon icon-print\"></span>\n    </button>\n    <div class=\"modal__text-container\">\n        <h1 class=\"modal__title style--underlined\" data-auto-translate=\"true\">\n            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsTitle"))), env.opts.autoescape);
output += "\n        </h1>\n\n        <div class=\"rich-text modal__text modal__text--intro\" data-auto-translate=\"true\">\n        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsText"))), env.opts.autoescape);
output += "\n        </div>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "jsFaqPageUrl")) {
output += "\n        <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsFaqPageUrl"), env.opts.autoescape);
output += "\" class=\"btn btn-solid btn-medium\" data-auto-translate=\"true\">See More FAQs</a>\n        ";
;
}
output += "\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["@modules/modals/templates/benefits-package-view.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./@modules/modals/templates/benefits-package-view.njk
// module id = 472
// module chunks = 0